import { fetchAPI } from "../redux/api";

export const emptyContentTranslations = () => ({ hi: {}, kn: {} });

export async function getContentTranslations(entityType, entityId) {
  if (!entityId) return emptyContentTranslations();
  const response = await fetchAPI(`ContentTranslations/${entityType}/${entityId}`);
  if (!response.ok) throw new Error("Could not load content translations.");
  const data = await response.json();
  return { ...emptyContentTranslations(), ...data };
}

export async function saveContentTranslations(entityType, entityId, translations = {}) {
  if (!entityId) return;
  const response = await fetchAPI(
    `ContentTranslations/${entityType}/${entityId}`,
    translations,
    "PUT"
  );
  if (!response.ok) throw new Error("Could not save content translations.");
}
